import { render, staticRenderFns } from "./appWebsite.vue?vue&type=template&id=4fc45fa8&scoped=true"
import script from "./appWebsite.vue?vue&type=script&lang=js"
export * from "./appWebsite.vue?vue&type=script&lang=js"
import style0 from "./appWebsite.vue?vue&type=style&index=0&id=4fc45fa8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc45fa8",
  null
  
)

export default component.exports